import { BASE_URL } from "constants/enum";

/** Normalizes a path: strips query/hash and trailing slash (except root). */
export const normalizePath = (path: string): string => {
    const without = path.split("?")[0].split("#")[0];
    if (without.length > 1 && without.endsWith("/")) {
        return without.slice(0, -1);
    }
    return without || "/";
};

/** Extracts pathname from an absolute or site-relative href. */
export const pathnameFromHref = (href: string): string => {
    if (href.startsWith("http")) {
        try {
            return new URL(href).pathname;
        } catch {
            return href;
        }
    }
    try {
        return new URL(href, BASE_URL).pathname;
    } catch {
        return href.startsWith("/") ? href : `/${href}`;
    }
};

/**
 * Removes Next.js i18n locale prefix from a path (`/es/foo` → `/foo`).
 * When locale is missing or `"default"`, returns the path unchanged.
 */
export const stripLocalePrefix = (
    pathname: string,
    locale: string | undefined
): string => {
    const pathOnly = normalizePath(pathname);
    if (!locale || locale === "default") {
        return pathOnly;
    }
    const prefix = `/${locale}`;
    if (pathOnly === prefix) {
        return "/";
    }
    if (pathOnly.startsWith(`${prefix}/`)) {
        return normalizePath(pathOnly.slice(prefix.length) || "/");
    }
    return pathOnly;
};
